import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgEos = function SvgEos(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M60 120C27 120 0 93 0 59.701.3 26.701 27-.298 60.3.002c33 .3 59.7 27 59.7 60.6C119.7 93.3 93 120 60 120",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M40.84 45.76 59.56 20l18.56 25.6 8 38.24L59.56 100 33 83.84zm2.4 7.36-5.92 28.96 19.36 11.84zm1.92-6.56 14.4-19.84 14.4 19.84-14.4 43.52zm30.56 6.56-13.44 40.8 19.36-11.84z",
        clipRule: "evenodd"
    })));
};

export { SvgEos as ReactComponent };
//# sourceMappingURL=EOS.svg.es.js.map
